<template>
  <div class="nav-bar"
       v-if="!isLoading">
    <b-navbar toggleable="lg"
              :style="{backgroundColor}">
      <b-navbar-brand href="#"
                      class="pl-10">
        <img :src="dynamicData.header.logo"
             class="mr-1 logo"
             alt="logo image">
      </b-navbar-brand>
      <b-navbar-toggle target="nav_collapse" />
      <b-collapse is-nav
                  id="nav_collapse">
        <b-navbar-nav class="ml-5">
          <li class="nav-item"
              v-for="menu in dynamicData.menu"
              v-bind:key="menu.title">
            <a target="_self"
               :style="{color}"
               :href="menu.url"
               v-track-event:link="{ url: menu.url }"
               class="nav-link">{{menu.title}}</a>
          </li>
          <!-- <b-nav-item-dropdown text="More" right v-if="dynamicData.moreMenuItems.length > 0">
          <b-dropdown-item href="#" v-for="menu in dynamicData.moreMenuItems" v-bind:key="menu.title">{{menu.title}}</b-dropdown-item>
          </b-nav-item-dropdown>-->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('app', ['dynamicData', 'isLoading']),
    backgroundColor: function () {
      return this.dynamicData.header ? this.dynamicData.header.backgroundColor : '#FFFFFF'
    },
    color: function () {
      return this.dynamicData.header ? this.dynamicData.header.color : '#000000'
    }
  }
}

</script>

<style lang="scss" scoped>
.navbar-brand {
  font-weight: bold;
  font-size: 1.5rem;
  color: $color-text-white !important;
  margin: 0 auto;
  display: table;
  img {
    width: 10rem;
  }
}
.nav-link {
  padding-top: 10px;
  font-size: 15px;
  text-transform: uppercase;
}

.router-link-exact-active {
  font-weight: 500;
}
</style>
